const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://intraweb.udi.edu.co/rev_mat_back/public/api';
const VERIFY_API_URL = (process.env.REACT_APP_VERIFY_URL || '').replace(/\/+$/, '');

export const endpoints = {
    validarMaterias: `${API_BASE_URL}/validar-materias`,
    materias: (documento) => `${API_BASE_URL}/materias/${documento}`,
    periodoActivo: `${API_BASE_URL}/periodo-activo`,
    generarPdf: (documento) => `${API_BASE_URL}/generar-pdf/${documento}`,
    preguntasEstudiante: (documento) => `${VERIFY_API_URL}/preguntas-estudiante/${documento}`,
    validarRespuestas: `${VERIFY_API_URL}/validar-respuesta`,
    verificarEstudiante: (documento) => `${VERIFY_API_URL}/existencia/${documento}`,
    loginEstudiante: `${API_BASE_URL}/login-estudiante`,
    estadoSistema: `${VERIFY_API_URL}/estado`,
    roles: `${API_BASE_URL}/roles`,
    login: `${API_BASE_URL}/login`,
    userInfo: `${API_BASE_URL}/user-info`,
    estudiantesPorPrograma: (programaId) => `${API_BASE_URL}/estudiantes-programa/${programaId}`,
    estudiantesSinRevision: (programaId, periodoActivo) => `${API_BASE_URL}/estudiantes-sin-revision/${programaId}`,
    estadisticasRevision: (periodoId) => `${API_BASE_URL}/estudiantes-sin-revision`,
    programas: `${API_BASE_URL}/programas`,
    usuarios: {
        listar: `${API_BASE_URL}/users`,
        crear: `${API_BASE_URL}/register`,
        actualizar: (id) => `${API_BASE_URL}/users/${id}`,
        eliminar: (id) => `${API_BASE_URL}/users/${id}`,
    }
};
